export default {
    FILE: 'file',
    FOLDER: 'folder',
    BOOKMARK: 'web_link',
};
